import controller from './kpath.controller';
import template from './kpath.html';

export default {
	template,
	bindings: {
		change:           '&?ngChange',
		disabled:         '<?ngDisabled',
		kid:              '<',
		options:          '=?',
		placeholder:      '@?',
		required:         '<?ngRequired',
		validatorPathMax: '<?',
		validatorPathMin: '<?',
		values:           '<ngModel',
	},
	controller,
	require:  {
		ngModelCtrl: '?ngModel',
		parent:      '^^?kform',
	},
};
